import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 3.005c2.755 0 5.455.232 8.083.677.533.09.917.556.917 1.097v1.044a2.25 2.25 0 0 1-.659 1.59l-5.432 5.433a2.25 2.25 0 0 0-.659 1.59v2.928a2.25 2.25 0 0 1-1.244 2.012l-3.256 1.63v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.414A2.25 2.25 0 0 1 3 5.823V4.779c0-.54.384-1.006.917-1.097A48.3 48.3 0 0 1 12 3.005"
    }, null, -1)
  ])))
}
export default { render: render }